<template>
	<div
		class="categories-container"
		:class="{
			'categories-container-full-image': fullImage && !scrollActive,
			'categories-container-scroll-active': scrollActive,
		}"
	>
		<div
			class="categories-selector"
			:class="{
				'categories-full-image': fullImage && !scrollActive,
				'categories-scroll-active': scrollActive,
			}"
		>
			<div class="categories-selector-container">
				<v-btn
					class="categories-selector-indicator indicator-left"
					color="newprimary"
					:disabled="disabledLeft"
					icon
					@click="slide('left')"
				>
					<v-icon color="white">keyboard_arrow_left</v-icon>
				</v-btn>
				<div class="categories-selector-item item-all">
					<v-btn
						class="btn-auto categories-selector-item-btn ma-0"
						:class="{ 'primary' : showAll && !scrollActive }"
						:color="colorAll"
						:style="`${fullImage && !scrollActive ? 'background: url(/static/images-new/sections/background-categories-1.jpg)' : '' }`"
						depressed
						flat
						@click="$emit('selected-all')"
					>
						<div class="opacity" v-if="fullImage && !scrollActive"></div>
						<span :class="showAll ? 'w-black fs-16' : 'w-bold fs-14'">TODOS</span>
					</v-btn>
				</div>
				<div class="categories-selector-items">
					<div
						class="categories-selector-items-container"
						:style="`transform: translateX(${transitionValue}px)`"
					>
						<div
							v-for="category in categories" :key="category.id"
							class="categories-selector-item"
						>
							<v-btn
								class="btn-auto categories-selector-item-btn ma-0"
								:class="{ 'primary' : category.selected }"
								:color="colorSelected(category)"
								:style="styleCategory(category)"
								depressed
								flat
								@click="$emit('selected-category', $event)"
							>
								<div class="opacity" v-if="fullImage && !scrollActive"></div>
								<img
									:class="{ 'image-active' : category.selected }"
									:src="category.icon"
									:alt="category.name"
									:height="category.height"
								/>
								<p class="mt-1 mb-0 w-bold fs-14">
									<span>{{ category.name }}</span>
								</p>
							</v-btn>
						</div>
					</div>
				</div>
				<v-btn
					class="categories-selector-indicator indicator-right"
					color="newprimary"
					:disabled="transitionValue === 0"
					icon
					@click="slide('right')"
				>
					<v-icon color="white">keyboard_arrow_right</v-icon>
				</v-btn>
			</div>
		</div>
		<div class="categories-switch" v-if="!scrollActive">
			<template v-if="fullImage">
				<span class="categories-switch-title">Categorías</span>
			</template>
			<template v-else>
				<label
					class="caption w-medium primary--text hidden-sm-and-down"
					:style="display === 1 ? 'padding-right: 45px' : 'padding-left: 40px'"
				>
					{{ displayLabel }}
				</label>
				<switch-display
					model="display"
					:false-value="1"
					:model-value="display"
					:true-value="2"
					@on-switch-change="$emit('on-switch-change', $event)"
				></switch-display>
			</template>
		</div>
	</div>
</template>

<script>
	import switchDisplay from '@/components/market-place/switch-display';

	function beforeDestroy() {
		window.removeEventListener('resize', this.calculateWidth());
	}

	function created() {
		window.addEventListener('resize', this.calculateWidth());
	}

	function calculateWidth() {
		this.width = window.innerWidth;
	}

	function colorAll() {
		if (this.scrollActive) {
			return this.showAll ? 'newwarning' : 'newaccent';
		}
		return this.showAll ? 'white' : 'newaccent';
	}

	function colorSelected({ selected }) {
		if (this.scrollActive) {
			return selected ? 'newwarning' : 'newaccent';
		}
		return selected ? 'white' : 'newaccent';
	}

	function disabledLeft() {
		let cardValue = 115;
		if (this.scrollActive) {
			cardValue = 140;
		} else if (this.fullImage) {
			cardValue = 126;
		}
		const validateLeftSlide = this.categories.length - this.totalSlideShow;
		return this.categories.length <= this.totalSlideShow ||
			(this.categories.length > this.totalSlideShow &&
			this.transitionValue === -(cardValue * validateLeftSlide));
	}

	function displayLabel() {
		return Number(this.display) === 1 ? 'Mapa' : 'Lista';
	}

	function slide(code) {
		let currentValue = 115;
		if (this.scrollActive) {
			currentValue = 140;
		} else if (this.fullImage) {
			currentValue = 126;
		}
		if (code === 'left') {
			this.transitionValue -= currentValue;
		} else if (code === 'right') {
			this.transitionValue += currentValue;
		}
	}

	function styleCategory({ background }) {
		return this.fullImage && !this.scrollActive ? `background: url('${background}')` : '';
	}

	function totalSlideShow() {
		if (this.width === 320) {
			return 1;
		} else if (this.width === 600) {
			return 3;
		} else if (this.width === 768) {
			return 4;
		} else if (this.width === 936) {
			return 6;
		} else if (this.width === 1200) {
			return 8;
		}
		return 8;
	}

	function data() {
		return {
			style: false,
			transitionValue: 0,
			width: 0,
		};
	}

	export default {
		name: 'categories-selector',
		beforeDestroy,
		components: {
			switchDisplay,
		},
		computed: {
			colorAll,
			disabledLeft,
			displayLabel,
			totalSlideShow,
		},
		created,
		data,
		methods: {
			calculateWidth,
			colorSelected,
			slide,
			styleCategory,
		},
		props: {
			display: [Number, String],
			categories: {
				default: () => [],
				type: Array,
			},
			fullImage: {
				default: false,
				type: Boolean,
			},
			scrollActive: {
				default: false,
				type: Boolean,
			},
			showAll: {
				default: false,
				type: Boolean,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.categories-selector {
		background-color: color(white);
		box-shadow: 0 2px 11px 0 rgba(0, 0, 0, 0.08);
		display: flex;
		position: relative;
		transition: all 1s ease-in-out;

		.item-all {
			z-index: 1;
		}

		&-items {
			display: flex;
			overflow: hidden;
			max-width: 115px;

			&-container {
				display: flex;
			}

			@media (min-width: 600px) {
				max-width: calc(115px * 3);
			}

			@media (min-width: 768px) {
				max-width: calc(115px * 4);
			}

			@media (min-width: 936px) {
				max-width: calc(115px * 6);
			}

			@media (min-width: 1200px) {
				max-width: calc(115px * 8);
			}
		}

		&-item {
			display: inline-flex;

			&-btn {
				border-radius: 0px !important;
				padding: 5px 0px;
				width: 115px !important;

				@media (min-width: 936px) {
					height: 109px !important;
					padding: 0px;
				}
			}
		}

		.image-active {
			filter: brightness(0) invert(1);
		}

		&-indicator {
			bottom: 0px;
			height: 25px;
			margin: auto;
			position: relative;
			top: 0px;
			width: 25px;

			&.indicator-left {
				@media (min-width: 1280px) {
					margin-right: auto;
				}
			}

			&.indicator-right {
				@media (min-width: 1280px) {
					margin-left: auto;
				}
			}

			@media (min-width: 1280px) {
				margin: auto 0;
			}
		}

		&-container {
			display: flex;
			margin: 0 auto;
			max-width: 1200px;
			width: 100%;
		}

		&.categories-full-image {
			background-color: transparent !important;
			box-shadow: none !important;

			.categories-selector-item-btn {
				border-radius: 16px !important;
				height: 117px !important;
				margin: 0px 4px !important;
				width: 118px !important;

				@media (min-width: 936px) {
					height: 147px !important;
					margin: 0px 8px !important;
					width: 148px !important;
				}

				.opacity {
					background-color: rgba(0, 0, 0, .53);
					border-radius: 16px;
					height: 100%;
					position: absolute;
					width: 100%;

					& + span {
						position: relative;
					}

					& + img {
						filter: brightness(0) invert(1);

						& + p {
							color: color(white) !important;
							position: relative;
						}
					}
				}
			}

			.categories-selector-container {
				overflow: hidden;
				max-width: 1250px !important;
			}

			.categories-selector-items {
				max-width: 128px !important;

				@media (min-width: 600px) {
					max-width: calc(148px * 3) !important;
				}

				@media (min-width: 768px) {
					max-width: calc(148px * 4) !important;
				}

				@media (min-width: 936px) {
					max-width: calc(148px * 6) !important;
				}

				@media (min-width: 1200px) {
					max-width: calc(148px * 8) !important;
				}
			}

			.categories-selector-indicator {
				@media (min-width: 936px) {
					height: 38px !important;
					width: 38px !important;
				}

				.icon {
					@media (min-width: 936px) {
						font-size: size(xlarge) !important;
					}
				}
			}
		}

		&.categories-scroll-active {
			background-color: color(newbackground) !important;
			box-shadow: 0 2px 11px 0 rgba(0, 0, 0, .08) !important;

			.categories-selector-item-btn {
				height: 61px !important;
				margin: 0px 14px !important;
				width: min-content !important;
				width: -moz-min-content !important;
			}

			.categories-selector-items {
				max-width: 140px !important;

				@media (min-width: 600px) {
					max-width: calc(140px * 3) !important;
				}

				@media (min-width: 768px) {
					max-width: calc(140px * 4) !important;
				}

				@media (min-width: 936px) {
					max-width: calc(140px * 6) !important;
				}

				@media (min-width: 1200px) {
					max-width: calc(140px * 8) !important;
				}
			}
		}
	}

	.categories-container {
		position: relative;
		top: 82px;
		z-index: 1;

		.categories-switch {
			align-items: center;
			background-color: color(white);
			border-bottom-left-radius: 57px;
			border-bottom-right-radius: 57px;
			box-shadow: 0 8px 11px 0 rgba(0, 0, 0, 0.08);
			display: flex;
			flex-direction: column;
			height: 45px;
			justify-content: center;
			left: 0px;
			margin: 0 auto;
			position: relative;
			right: 0px;
			top: 0px;
			width: 135px;
			z-index: 2;

			@media (min-width: 936px) {
				border-bottom-left-radius: 96px;
				border-bottom-right-radius: 96px;
				height: 84px;
				width: 186px;
			}
		}

		&.categories-container-full-image {
			.categories-switch {
				background-color: color(newbackground) !important;
				border-bottom-left-radius: 0px !important;
				border-bottom-right-radius: 0px !important;
				border-top-left-radius: 57px !important;
				border-top-right-radius: 57px !important;
				box-shadow: none !important;
				top: -195px !important;

				@media (min-width: 936px) {
					border-bottom-left-radius: 0px !important;
					border-bottom-right-radius: 0px !important;
					border-top-left-radius: 96px !important;
					border-top-right-radius: 96px !important;
					top: -248px !important;
				}

				&-title {
					color: color(secondary);
					font-size: size(medium18);
					font-weight: weight(black);
				}
			}
		}

		&.categories-container-scroll-active {
			position: fixed !important;
			top: 61px !important;
			width: 100% !important;

			@media (min-width: 936px) {
				top: 82px !important;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/market-place/categories-selector.vue